// The build injects a hash of the shipped Content folder. Keep logical content names unchanged:
// only network URLs get a cache key (the core/protocol still sees Content/Game/... names).
declare const __ASHENHEART_ASSET_VERSION__: string;

export function assetUrl(path: string): string {
  if (typeof __ASHENHEART_ASSET_VERSION__ === 'undefined') return path; // tests/custom bundles
  const [url, fragment] = path.split('#', 2);
  return `${url}${url.includes('?') ? '&' : '?'}v=${__ASHENHEART_ASSET_VERSION__}${fragment === undefined ? '' : `#${fragment}`}`;
}
